import { FormControl, Grid, TextField, Typography } from '@mui/material'
import React from 'react'

export default function SectionInfoVehicle({FormRequestGlobal}) {

  const { formState, onInputChange, onSelectSearchChange } = FormRequestGlobal
  return (
    <>
      <Typography sx={{mt:3,fontWeight: 'bold'}} variant='subtitle2'>
        Informacion del vehiculo
      </Typography>
      <div className="border-bottom border-dark"></div>
      <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2, mt: 2 }}>
        <Grid item xs={12} sm={12} md={4} lg={4}>
            <FormControl fullWidth>
              <label htmlFor="tipo">* Tipo de Vehiculo</label>
                <TextField
                    id='tipo'
                    name='tipo'
                    value={ formState.tipo }
                    onChange={ onInputChange }
                    size='small'
                    placeholder='Tipo de Vehiculo'
                    type='text'
                    variant='filled'
                    InputProps={{
                        readOnly:  true 
                    }}
                    required
                />
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={12} md={4} lg={4}>
            <FormControl fullWidth>
              <label htmlFor="marca">* Marca</label>
                <TextField
                    id='marca'
                    name='marca'
                    value={ formState.marca }
                    onChange={ onInputChange }
                    size='small'
                    placeholder='Marca'
                    type='text'
                    variant='filled'
                    InputProps={{
                        readOnly:  true 
                    }}
                    required
                />
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={12} md={4} lg={4}>
            <FormControl fullWidth>
              <label htmlFor="modelo">* Modelo</label>
                <TextField
                    id='modelo'
                    name='modelo'
                    value={ formState.modelo }
                    onChange={ onInputChange }
                    size='small'
                    placeholder='Modelo'
                    type='text'
                    variant='filled'
                    InputProps={{
                        readOnly:  true 
                    }}
                    required
                />
            </FormControl>
          </Grid>
      </Grid>

      <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2 }}>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <FormControl fullWidth>
            <label htmlFor="linea">* Linea</label>
              <TextField
                  id='linea'
                  name='linea'
                  value={ formState.linea }
                  onChange={ onInputChange }
                  size='small'
                  placeholder='Linea'
                  type='text'
                  variant='filled'
                  InputProps={{
                      readOnly:  true 
                  }}
                  required
              />
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={6}>
          <FormControl fullWidth>
            <label htmlFor="color">* Color</label>
              <TextField
                  id='color'
                  name='color'
                  value={ formState.color }
                  onChange={ onInputChange }
                  size='small'
                  placeholder='Color'
                  type='text'
                  variant='filled'
                  InputProps={{
                      readOnly:  true 
                  }}
                  required
              />
          </FormControl>
        </Grid>
      </Grid>
      <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2 }}>
        
        <Grid item xs={12} sm={12} md={2} lg={2}>
          <FormControl fullWidth>
            <label htmlFor="motorCC">* Cilindrada del Motor</label>
              <TextField
                  id='motorCC'
                  name='motorCC'
                  value={ formState.motorCC }
                  onChange={ onInputChange }
                  size='small'
                  placeholder='Cilindrada del Motor'
                  type='text'
                  variant='filled'
                  InputProps={{
                      readOnly:  true 
                  }}
                  required
              />
          </FormControl>
        </Grid>
                
        <Grid item xs={12} sm={12} md={2} lg={2}>
          <FormControl fullWidth>
            <label htmlFor="matricula">* Matricula</label>
              <TextField
                  id='matricula'
                  name='matricula'
                  value={ formState.matricula }
                  onChange={ onInputChange }
                  size='small'
                  placeholder='Matricula'
                  type='text'
                  variant='filled'
                  InputProps={{
                      readOnly:  true 
                  }}
                  required
              />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={4}>
          <FormControl fullWidth>
            <label htmlFor="motorNo">* No. de Motor</label>
              <TextField
                  id='motorNo'
                  name='motorNo'
                  value={ formState.motorNo }
                  onChange={ onInputChange }
                  size='small'
                  placeholder='No. de Motor'
                  type='text'
                  variant='filled'
                  InputProps={{
                      readOnly:  true 
                  }}
                  required
              />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={4}>
          <FormControl fullWidth>
            <label htmlFor="chasis">* No. de Chasis</label>
              <TextField
                  id='chasis'
                  name='chasis'
                  value={ formState.chasis }
                  onChange={ onInputChange }
                  size='small'
                  placeholder='No. de Chasis'
                  type='text'
                  variant='filled'
                  InputProps={{
                      readOnly:  true 
                  }}
                  required
              />
          </FormControl>
        </Grid>
      </Grid>
    </>
  )
}
